import React from "react"
import { injectIntl } from "react-intl"
import { Grid, Typography, Box } from "@material-ui/core"
import { Button } from "@ridecell/web-components-material"
import LaunchIcon from "@material-ui/icons/Launch"
import useGlobalContext from "../../../utils/customHooks/useGlobalContext"
import messages from "./messages"

const RegistrationSuccess = ({ intl: { formatMessage } }) => {
  const {
    state: { tenantSettings },
  } = useGlobalContext()
  const isMobile = /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(
    navigator.userAgent
  )
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const isAndorid = isMobile && /android/i.test(userAgent)
  const isIOS =
    isMobile && /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream

  const displayAppLinks = () => {
    return (
      <React.Fragment>
        {isAndorid && playStoreLink()}
        {isIOS && appStoreLink()}
        {!isMobile && (
          <Box display="flex" flexWrap={"wrap"} justifyContent="center">
            {appStoreLink("IOS")}
            {playStoreLink("ANDROID")}
          </Box>
        )}
      </React.Fragment>
    )
  }

  const appStoreLink = (device = "") => {
    return (
      tenantSettings?.iosAppLink && (
        <Button
          color="secondary"
          size="small"
          startIcon={<LaunchIcon />}
          variant="contained"
          style={{ marginRight: "16px" }}
          onClick={() => window.open(tenantSettings.iosAppLink, "_blank")}
        >
          {formatMessage(messages.downloadApp, {
            device,
          })}
        </Button>
      )
    )
  }

  const playStoreLink = (device = "") => {
    return (
      tenantSettings?.androidAppLink && (
        <Button
          color="secondary"
          size="small"
          startIcon={<LaunchIcon />}
          variant="contained"
          onClick={() => window.open(tenantSettings.androidAppLink, "_blank")}
        >
          {formatMessage(messages.downloadApp, {
            device,
          })}
        </Button>
      )
    )
  }

  return (
    <Grid xs={12} md={10} lg={10} container justify="center">
      <Box
        display="flex"
        flexDirection="column"
        marginTop={"32px"}
        alignItems="center"
      >
        <Box
          display="flex"
          sx={{ mb: "16px", textAlign: "center" }}
          justifyContent="center"
        >
          <Typography variant="h5">
            {formatMessage(messages.successMessage)}
          </Typography>
        </Box>
        <Box
          display="flex"
          sx={{ mb: "16px", textAlign: "center" }}
          justifyContent="center"
        >
          <Typography variant="subtitle">
            {formatMessage(messages.verificationMessage)}
          </Typography>
        </Box>
        {(tenantSettings?.androidAppLink || tenantSettings.iosAppLink) &&
          displayAppLinks()}
        <Box
          display="flex"
          sx={{ mt: "16px", textAlign: "center" }}
          justifyContent="center"
        >
          <Typography variant="caption">
            {formatMessage(messages.confirmationMessage)}
          </Typography>
        </Box>
      </Box>
    </Grid>
  )
}

export default injectIntl(RegistrationSuccess)
